module.exports = __webpack_public_path__ + "img/chat-icon.2745f781.png";